import { gql } from '@/__generated__';

const SEND_FEEDBACK = gql(`#graphql
  mutation SendFeedback($input: SendFeedbackInput!) {
    sendFeedback(input: $input) {
      response
    }
  }
`);

export default SEND_FEEDBACK;
